module.exports = __webpack_public_path__ + "img/calculator.cf7daaa1.svg";